/**
 * Transforms a string containing a person's first and last names into a capitalized string of initials
 * @param fullName a string with a first and last name - example: "John Smith"
 * @returns a string with capitalized initials - example: "JS"
 */
export const getInitialsFromFullName = (fullName: string): string =>
  fullName
    .split(" ")
    .map((string) => string[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
